import React, { useEffect } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { setLoadingStatus } from 'src/common/explorer/lib/redux/slices/loadingSlice';
import { swapCountryAndLanguage, urlShouldBeLocalized } from '../utils';
import { LinkType } from 'src/common/explorer/lib/types';
import ProductsDisplay from './ProductsDisplay';
import {
  useProductExplorerDispatch,
  useProductExplorerSelector,
} from '../lib/redux/hooks';
import './ProductExplorer.scss';
import { Link, Loading, Button } from 'carbon-components-react';
import { CarbonThemes } from 'src/types/carbon';

export interface ProductExplorerProps {
  linkType: LinkType.product | string;
}

const ProductExplorer: React.FC<ProductExplorerProps> = ({ linkType }) => {
  const loading = useProductExplorerSelector<boolean>((state) => state.loading);
  const theme = useProductExplorerSelector<CarbonThemes>(
    (state) => state.theme,
  );
  const messages = useProductExplorerSelector<
    Record<string, MessageDescriptor>
  >((state) => state.messages);

  const dispatch = useProductExplorerDispatch();

  let localeCode = useProductExplorerSelector((state) => state.localeCode);
  localeCode = swapCountryAndLanguage(localeCode);

  const satelliteLink = `https://www.ibm.com${
    urlShouldBeLocalized(localeCode) ? `/${localeCode}` : ''
  }/products/satellite`;

  useEffect(() => {
    dispatch(setLoadingStatus(false));
  }, []);
  return (
    <div
      className={`product-explorer product-explorer__${theme} widget-styles`}
    >
      <div className="product-explorer__global widget-reset">
        <div className="product-explorer__headline-wrapper">
          <h3 className="product-explorer__headline bx--type-expressive-heading-05">
            <FormattedMessage {...messages.appHeadline} />
          </h3>
          <p className="product-explorer__subhead">
            <FormattedMessage {...messages.appSubhead} />
          </p>
          {localeCode === 'jp-ja' ? (
            <p className="product-explorer__subhead">
              <Link size="lg" href={satelliteLink}>
                <FormattedMessage {...messages.appSubheadC} />
              </Link>
              <FormattedMessage {...messages.appSubheadB} />
            </p>
          ) : (
            <p className="product-explorer__subhead">
              <FormattedMessage {...messages.appSubheadBA} />
              <a href={satelliteLink}>
                &nbsp;
                <FormattedMessage {...messages.appSubheadC} />
              </a>
              <Button href={satelliteLink} className="product-explorer__button">
                <FormattedMessage {...messages.appSubheadC} />
              </Button>
            </p>
          )}
        </div>
        <div>
          {loading ? (
            <Loading withOverlay={false} />
          ) : (
            <ProductsDisplay linkType={linkType} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductExplorer;
